import { Bounce, toast } from 'react-toastify';

import type { ToastAction } from '@/components/Toast/Toast';
import type { ToastPosition } from 'react-toastify';

import { Toast } from '@/components/Toast/Toast';

interface ToastProps {
    position: ToastPosition;
    autoClose: number;
    hideProgressBar: boolean;
    closeOnClick: boolean;
    pauseOnHover: boolean;
    draggable: boolean;
    progress: undefined;
    transition: typeof Bounce;
}

interface ToastNotificationProps {
    title?: string;
    message: string;
    action?: ToastAction;
}

const defaultConfig: ToastProps = {
    position: 'top-right' as ToastPosition,
    autoClose: 5000,
    hideProgressBar: false,
    closeOnClick: true,
    pauseOnHover: true,
    draggable: true,
    progress: undefined,
    transition: Bounce,
};

export const showErrorToast = ({ title, message, action }: ToastNotificationProps) => {
    toast.error(Toast, {
        ...defaultConfig,
        data: { title: title, message: message, action: action },
    });
};

export const showSuccessToast = ({ title, message, action }: ToastNotificationProps) => {
    toast.success(Toast, {
        ...defaultConfig,
        data: { title: title, message: message, action: action },
    });
};

export const showWarningToast = ({ title, message, action }: ToastNotificationProps) => {
    toast.warning(Toast, {
        ...defaultConfig,
        data: { title: title, message: message, action: action },
    });
};
